module.exports = __webpack_public_path__ + "static/media/bkg01n.48cac7cf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/backgrounds/bkg01n.jpg
// module id = 464
// module chunks = 0